var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backToPre"},[_c('img',{staticClass:"backImg",attrs:{"src":require("../static/img/left.png"),"alt":""},on:{"click":_vm.backPre}}),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }